module.exports = ".modal-body .row .myText {\n  font-weight: 500;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/breakdowns/breakdowns-details/breakdowns-details.component.css
// module id = ./src/app/breakdowns/breakdowns-details/breakdowns-details.component.css
// module chunks = main